<template>
  <div class="dialog-component">
    <!-- :class="[visible ? 'dialog-fade-enter-active': 'dialog-fade-leave-active']" -->
    <div
      class="vk-dialog"
      :style="{width: width}"
    >
      <div
        v-if="showTitle"
        class="dialog-title"
      >
        <span>{{title}}</span>
        <img
          class="dialog-close"
          src="@/assets/images/detail/close.svg"
          @click="closeDialog"
        />
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '800px'
    }
  },
  watch: {
    visible: {
      handler: function (newVal, oldVal) {
        this.$nextTick(() => {
          this.setScroll(newVal ? 'hidden' : 'auto')
          if (newVal) {
            this.$el.style.display = 'block'
            this.addClass(this.$el, 'dialog-fade-enter-active')
          } else {
            this.addClass(this.$el, 'dialog-fade-leave-active')
            setTimeout(() => {
              this.removeClass(this.$el, 'dialog-fade-enter-active')
              this.removeClass(this.$el, 'dialog-fade-leave-active')
              this.$el.style.display = 'none'
            }, 280)
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    setScroll(style) {
      document.querySelector('body').style.overflow = style
    },
    closeDialog() {
      // this.$emit('update:visible', false)
      this.$emit('close')
    },
    hasClass(obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += " " + cls;
    },
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        obj.className = obj.className.replace(reg, ' ');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-component {
  display: none;
  z-index: 2007;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #333333;
  overflow: auto;
  .vk-dialog {
    position: relative;
    margin: 15vh auto 0;
    background-color: #fff;
    .dialog-title {
      position: relative;
      height: 60px;
      box-shadow: 0px 1px 0px 0px rgba(229, 229, 229, 1);
      padding: 17px 15px 18px 24px;
      background-color: #f8f8f8;
      span {
        display: inline-block;
        height: 25px;
        line-height: 25px;
        font-weight: 500;
        font-size: 18px;
      }
      .dialog-close {
        cursor: pointer;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .dialog-content {
      padding: 20px;
    }
  }
  &.dialog-fade-enter-active {
    -webkit-animation: dialog-fade-in 0.3s;
    animation: dialog-fade-in 0.3s;
  }
  &.dialog-fade-leave-active {
    -webkit-animation: dialog-fade-out 0.3s;
    animation: dialog-fade-out 0.3s;
  }
  @-webkit-keyframes dialog-fade-in {
    0% {
      -webkit-transform: translate3d(0, -20px, 0);
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @keyframes dialog-fade-in {
    0% {
      -webkit-transform: translate3d(0, -20px, 0);
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @-webkit-keyframes dialog-fade-out {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translate3d(0, -20px, 0);
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }
  @keyframes dialog-fade-out {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translate3d(0, -20px, 0);
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }
}
</style>
